import { FormattedMessage } from 'react-intl';

import { NoCards } from '@sorare/core/src/atoms/icons/NoCards.tsx';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM } from '@sorare/core/src/atoms/typography/index.tsx';

type Props = {
  children?: React.ReactNode;
};

export const LineupsEmptyState = ({ children }: Props) => (
  <Vertical center gap={2} style={{ minHeight: '500px' }}>
    <NoCards size={6} />
    <HeadlineM>
      <FormattedMessage defaultMessage="No lineups entered" />
    </HeadlineM>
    {children}
  </Vertical>
);
